/* Dansk katalog for locale-advisor-plan-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'adv.plan.viewForecast': 'Se prognose',
  'adv.plan.forecastTitle': 'Pengestrøm med planlagte hændelser',
  'adv.plan.forecastIntro': 'Sammenlign saldoen baseret på bogførte tal med saldoen efter de hændelser, du har registreret.',
  'adv.plan.forecastWithoutEvents': 'Uden planlagte hændelser',
  'adv.plan.forecastWithEvents': 'Med planlagte hændelser',
  'adv.plan.forecastChange': 'Ændring ved årets udgang',
  'adv.plan.forecastScope': 'Planlagte hændelser ændrer kun prognosen, ikke bogføringen eller budgettet. Saldoen stopper ved nul i kurven, så ændringen ved årets udgang kan være mindre end summen af hændelserne.',
  'adv.plan.showVariance': 'Vis afvigelser',
  'adv.plan.hideVariance': 'Skjul afvigelser',
});
